import React, { useEffect, useState, useMemo } from 'react';
import { Row, Col, Card, Space, DatePicker, Drawer, Form, Input, Select, Radio, message, Modal, Pagination, Tabs, Popover, Checkbox, InputNumber } from 'antd';
import { Table, Button } from 'antd';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import { DownOutlined, ExclamationCircleOutlined, PlusOutlined, CheckOutlined, CheckCircleOutlined, ClockCircleOutlined, HomeOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { ICardPunchRecord, pagePunchRecords } from '../../service/api/card';
import { IScheduleView, IScheduleColumn, IScheduleTime, ICellMap, ITeachClassCourse, ITeachClassCourseStudent, ITeachClassCourseFinish, courseSchedule, getCourseDetail, finishCourse } from '../../service/api/teachClass';
import { IStudent, listStudents } from '../../service/api/student';
import { ITeacher, listTeachers } from '../../service/api/teacher';
import { ICourseDefinition, listCourseDefinitions } from '../../service/api/courseDefinition';
import { ICardDefinition, listCardDefinitions } from '../../service/api/cardDefinition';
import { IClassroom, listClassrooms } from '../../service/api/classroom';
import moment from 'moment';
import { FormInstance } from 'antd/lib/form/Form';
import { DatePickerProps } from 'antd/lib/date-picker';
const { Option } = Select;
// import './scheduleList.less';
const { confirm } = Modal;
const { TabPane } = Tabs;

interface IScheduleListProps {
  filterStoreIds: number[] | undefined
}
const ScheduleList: React.FC<IScheduleListProps> = ({
  filterStoreIds,
}) => {
  const [scheduleView, setScheduleView] = useState<IScheduleView>();
  const [teachClassCourseDetail, setTeachClassCourseDetail] = useState<ITeachClassCourse>();
  const [teachClassCourseStudents, setTeachClassCourseStudents] = useState<ITeachClassCourseStudent[]>();
  const [teachClassCourseVisible, setTeachClassCourseVisible] = useState(false);
  const [cardDefinitions, setCardDefinitions] = useState<ICardDefinition[]>();
  const [weekIndex, setWeekIndex] = useState<number>(0);
  const [findDate, setFindDate] = useState<string>();
  const [modeType, setModeType] = useState<string>('sameTime');
  const [students, setStudents] = useState<IStudent[]>();
  const [teachers, setTeachers] = useState<ITeacher[]>();
  const [courseDefinitions, setCourseDefinitions] = useState<ICourseDefinition[]>();
  const [classroooms, setClassrooms] = useState<IClassroom[]>();
  const [pageNum, setPageNum] = useState(1);
  const [pageTotal, setPageTotal] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const formRef = React.createRef<FormInstance>();
  const [loading, setLoading] = useState(false);

  const content = (cell: ITeachClassCourse) => {
    return <>
      <p>计划上课时间：{moment(cell.planStartTime).format('YYYY-MM-DD HH:mm:ss')}</p>
      <p>上课教室：{cell.classroomName}</p>
      <p>消耗课时数：{cell.costValue}</p>
      <p>打卡情况：{cell.punchRecordCount}/{cell.studentCount}</p>
      <p>状态：{cell.status == 'finish' ? '已完成' : cell.status == 'plan' ? '未开始' : '已停课'}</p>
    </>
  };

  const columns = useMemo(
    () => [
      {
        title: '日期',
        dataIndex: 'timeCode',
        key: 'timeCode',
        width: '100',
        render: (text: any, record: any) => {
          return <div style={{ minWidth: '30px' }}>{record.timeName}</div>;
        },
      }
    ].concat(
      scheduleView?.columns?.map((item: IScheduleColumn) => {
        return {
          title: item.title,
          dataIndex: item.dataIndex,
          key: item.key,
          width: item.width,
          render: (text: any, record: any) => {
            const key = `${record.timeCode}|${item.key}`;
            const cellss = scheduleView?.cellMap[key];
            return <div style={{ minWidth: '110px' }}>{cellss ? (
              cellss.map((cells: any) => {
                return <div style={{ marginBottom: '5px', width: 'fit-content', display: 'flex' }}>
                  {cells.map((cell: ITeachClassCourse) => {
                    return <div style={{ marginBottom: '5px', marginRight: '5px' }}>
                      <Popover placement="right" content={content(cell)} trigger="hover">
                        {/* <Button type="primary" style={{ width: '140px', height: '52px', padding: '6px', boxShadow: '4px 4px 5px #909090',border:'1px' }} onClick={() => {
                                  setTeachClassCourseDetail(cell);
                                  setTeachClassCourseVisible(true);
                                  getCourseDetail(cell.id).then((info: any) => {
                                    setTeachClassCourseStudents(info.data.courseStudents);
                                  });
                                }} ghost> */}
                        <div style={{
                          width: '162px', height: '52px', padding: '6px', boxShadow: '4px 4px 5px #909090', border: '1px', borderRadius: '2px',
                          backgroundColor: `${cell.status == 'finish' ? '#f0fff0' : cell.status == 'stop' ? '#fff0f5' : '#ffffff'}`
                        }} onClick={() => {
                          setTeachClassCourseDetail(cell);
                          setTeachClassCourseVisible(true);
                          getCourseDetail(cell.id).then((info: any) => {
                            setTeachClassCourseStudents(info.data.courseStudents);
                          });
                        }}>
                          <div style={{ position: 'absolute' }}>
                            <div style={{ position: 'absolute', left: '-22px', top: '-8px' }}>
                              <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2952" width="40" height="40">
                                <path d="M736.465 849.121l-223.927-132.956-223.928 132.956v-647.563h447.855z" p-id="2953" fill={cell.classroomColor}></path>
                                <path d="M288.611 118.816h447.855v61.967h-447.855v-61.967z" p-id="2954" fill={cell.classroomColor}></path>
                              </svg>
                            </div>
                          </div>
                          <div style={{ alignItems: 'center', flexDirection: 'column' }}>
                            <div style={{ textAlign: 'center' }}>
                              <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
                                {cell.teachClassName}
                              </span>
                            </div>
                            <div style={{ alignItems: 'center' }}>
                              <span style={{ paddingLeft: '15px' ,fontSize: '10px' }}>
                                {cell.teacherName}  {cell.planStartTimeName}&nbsp;
                                      </span>
                              {cell.status == 'finish' ? <CheckCircleOutlined style={{ color: 'green' }} /> : cell.status == 'stop' ? <MinusCircleOutlined /> : <ClockCircleOutlined style={{ color: 'blue' }} />}
                            </div>
                          </div>
                          {/* </Button> */}
                        </div>
                      </Popover>
                    </div>
                  })}
                </div>
              }
              )
            ) : ('-')}</div>;
          },
        };
      }) || []
    ), [scheduleView]
  );

  const datas = useMemo(
    () => scheduleView?.times?.map((item) => {
      return {
        timeCode: item.timeCode,
        timeName: item.timeName,
      }
    }) || [], [scheduleView]
  );

  useEffect(() => {
    loadData();
  }, [weekIndex, filterStoreIds, modeType, findDate]);

  useEffect(() => {
    if (teachClassCourseDetail && teachClassCourseStudents) {
      let copyFormData = JSON.parse(JSON.stringify(teachClassCourseDetail))
      if (typeof (copyFormData.planStartTime) === 'string') {
        copyFormData.planStartTime = moment(new Date(copyFormData.planStartTime));
      }
      copyFormData.courseStudents = teachClassCourseStudents.map((student: ITeachClassCourseStudent) => {
        return student.punchRecord ? student.id : undefined;
      })
      // 设置100毫秒的延迟 确保from组件已经加载完毕
      setTimeout(() => {
        if (formRef.current) {
          formRef.current!.setFieldsValue(copyFormData);
        }
      }, 100);
    }
  }, [teachClassCourseDetail, teachClassCourseStudents]);

  const loadData = () => {
    courseSchedule(weekIndex, findDate || '', filterStoreIds || '', modeType).then((info: any) => {
      setScheduleView(info?.data);
    });
    listStudents().then((info: any) => {
      setStudents(info?.data);
    });
    listTeachers().then((info: any) => {
      setTeachers(info?.data);
    });
    listCourseDefinitions().then((info: any) => {
      setCourseDefinitions(info?.data);
    });
    listClassrooms().then((info: any) => {
      setClassrooms(info?.data);
    });
    listCardDefinitions().then((info: any) => {
      setCardDefinitions(info?.data);
    });
  }

  const onFinish = (values: any) => {
    setLoading(true);
    console.log("values:" + values);
    if (teachClassCourseDetail) {
      // console.log("infox:" + JSON.stringify(values.courseStudents));
      // values.courseStudents = values.courseStudents.filter((studentId:any) => {
      //   return studentId;
      // })
      console.log("infox:" + JSON.stringify(values.courseStudents));
      const vv = values.courseStudents.filter((record: any) => !!record);
      console.log("infox1:" + JSON.stringify(vv));
      if (vv.length != 0) {
        finishCourse({
          ...values,
          id: teachClassCourseDetail.id,
          punchRecordStudentIds: values.courseStudents,
        }).then((info: any) => {
          console.log("info:" + JSON.stringify(info))
          if (info.code === '200') {
            message.success("更新成功");
            setLoading(false);
            onClose();
            loadData();
          }
        });
      } else {
        message.info("请勾选需要打卡的学员，否则无法完成课程");
      }
    }
  };

  const onChange: DatePickerProps['onChange'] = (date, dateString) => {
    console.log(date, dateString);
    setFindDate(dateString)
  }

  const onClose = () => {
    setTeachClassCourseDetail(undefined);
    setTeachClassCourseVisible(false);
    if (formRef.current) {
      formRef.current!.resetFields();
    }
  }

  const onPageChange = (pageNum: number, pageSize: number) => {
    console.log("pageNum:" + pageNum);
    console.log("pageSize:" + pageSize);
    setPageNum(pageNum);
    setPageSize(pageSize);
    // setPageSize(info.data.pageSize);
  }

  function range(start: number, end: number) {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  }

  // 下拉框值
  const teacherOptions = teachers?.map((teacher) =>
    <Option key={teacher.id} value={teacher.id}>{teacher.name}</Option>);

  // 下拉框值
  const classroomOptions = classroooms?.map((classrooom) =>
    <Option key={classrooom.id} value={classrooom.id}>{classrooom.name}</Option>);

  // 下拉框值
  const courseDefinitionOptions = courseDefinitions?.map((courseDefinition) =>
    <Option key={courseDefinition.id} value={courseDefinition.id}>{courseDefinition.name}</Option>);

  // 下拉框值
  const cardDefinitionOptions = cardDefinitions?.map((cardDefinition) =>
    <Option key={cardDefinition.id} value={cardDefinition.id}>{cardDefinition.name}</Option>);

  const courseStudentOption = useMemo(
    () => teachClassCourseStudents?.map((student: ITeachClassCourseStudent) => {
      return {
        label: student.name,
        value: student.id,
        // disabled: student.punchRecord,
      }
    }) || [], [teachClassCourseStudents]
  );
  

  const [checkedList, setCheckedList] = React.useState([]);
  const [indeterminate, setIndeterminate] = React.useState(true);
  const [checkAll, setCheckAll] = React.useState(false);

  const onCheckAllChange = (e: { target: { checked: React.SetStateAction<boolean>; }; }) => {
    // setCheckedList(e.target.checked ? courseStudentOption : []);
    setIndeterminate(false);
    setCheckAll(e.target.checked);
    if (e.target.checked) {
      // setTeachClassCourseDetail(undefined);
      setTeachClassCourseStudents(teachClassCourseStudents?.map((student: ITeachClassCourseStudent) => {
        return {
          id: student.id,
          name: student.name,
          punchRecord: true,
        };
      }))
      console.log("infox:" + JSON.stringify(teachClassCourseStudents));
    }else{
      setTeachClassCourseStudents(teachClassCourseStudents?.map((student: ITeachClassCourseStudent) => {
        return {
          id: student.id,
          name: student.name,
          punchRecord: false,
        };
      }))
    }
  };

  return (
    <div>
      <Card bordered={false}>
        <div style={{}}>
          <Table
            dataSource={datas}
            columns={columns}
            pagination={false}
            scroll={{ x: 'true' }}
            style={{ minHeight: '500px' }}
          />
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", paddingTop: "10px" }}>
           <DatePicker
                  placeholder="请选择具体日期"
                  onChange={onChange}
                  style={{ width:'150px',right: '10px' }}
                />
          <Button type="primary" onClick={() => {
            setWeekIndex(weekIndex - 1);
          }}>上一周</Button>
          <Button type="primary" onClick={() => {
            setWeekIndex(weekIndex + 1);
          }}>下一周</Button>
          <Button type="default" onClick={() => {
            if (modeType == 'sameTime') {
              setModeType('list');
            } else {
              setModeType('sameTime');
            }
          }}>模式切换</Button>
        </div>
      </Card>
      <Drawer
        title={teachClassCourseDetail ? "班级课程详情" : "新增班级课程"}
        visible={teachClassCourseVisible}
        width={720}
        onClose={onClose}
        bodyStyle={{ paddingBottom: 80 }}
        destroyOnClose
      >
        <Form onFinish={onFinish} ref={formRef} layout="vertical" hideRequiredMark>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="teachClassName"
                label="班级名称"
                rules={[{ required: true, message: '请填写班级名称' }]}
              >
                <Input disabled={true} placeholder="请填写班级名称" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="teacherId"
                label="教师"
                rules={[{ required: false, message: '请选择负责该课程的教师' }]}
              >
                <Select placeholder="请选择负责该课程的教师"
                  showSearch
                  filterOption={(input, option) =>
                    option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }>
                  {teacherOptions}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="classroomId"
                label="教室"
                rules={[{ required: true, message: '请选择上课的教室' }]}
              >
                <Select placeholder="请选择上课的教室"
                  showSearch
                  filterOption={(input, option) =>
                    option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }>
                  {classroomOptions}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="courseDefinitionId"
                label="课程"
                rules={[{ required: true, message: '请选择课程' }]}
              >
                <Select placeholder="请选择课程"
                  showSearch
                  filterOption={(input, option) =>
                    option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }>
                  {courseDefinitionOptions}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="priorityConsumeCardId"
                label="优先消耗的课包"
                rules={[{ required: false, message: '请选择优先消耗的课包' }]}
              >
                <Select placeholder="请选择优先消耗的课包"
                  showSearch
                  filterOption={(input, option) =>
                    option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }>
                  {cardDefinitionOptions}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="remark"
                label="备注"
                rules={[{ required: false, message: '请输入备注' }]}
              >
                <Input placeholder="请输入备注" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="planStartTime"
                label="上课时间"
                rules={[{ required: true, message: '请选择上课时间' }]}
              >
                <DatePicker
                  format="YYYY-MM-DD HH:mm"
                  showTime
                />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item
                name="costValue"
                label="消耗课时数"
                rules={[{ required: true, message: '请输入消耗课时数' }]}
              >
                <InputNumber min={1} max={10} step={0.5}/>
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item
                name="costHour"
                label="上课时长"
                rules={[{ required: true, message: '请输入上课时长' }]}
              >
                <InputNumber min={1} max={10} step={0.5}/>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="courseStudents"
                label="学员打卡"
                rules={[{ required: false, message: '请选择按时打卡的学员' }]}
                extra={
                  <Checkbox indeterminate={indeterminate} onChange={onCheckAllChange} checked={checkAll}>
                    全选
                    </Checkbox>
                }
              >
                <Checkbox.Group style={{ fontSize: '30px' }} options={courseStudentOption} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item>
                <Button type="primary" htmlType="submit"  loading={loading}>完成课程（批量打卡）</Button>
                <Button htmlType="button" onClick={onClose}>取消</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </div>
  );
};

export default ScheduleList;
